var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAsteriskSimple = function SvgIconAsteriskSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.75a1 1 0 0 1 1 1v6.874l6.538-2.125a1 1 0 0 1 .618 1.902l-6.538 2.125 4.039 5.561a1 1 0 0 1-1.619 1.176l-4.037-5.561-4.038 5.56a1 1 0 1 1-1.619-1.175l4.039-5.561L3.845 10.4a1 1 0 1 1 .618-1.902L11 10.624V3.75a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};
export default SvgIconAsteriskSimple;